module.exports = __webpack_public_path__ + "img/changyuanAppImage.c7f7c7cb.png";